module.exports = __webpack_public_path__ + "static/media/022.56b73a82.webp";